module.exports = __webpack_public_path__ + "img/1@s.cef5abc2.jpg";